//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";

export default {
  name: "PhantomForm",
  props: ["value"],
  components: {},
  mounted: function() {
    BackendServices.getReasonCodeList().then(response => {
      this.reasonCodeList = response.data;
    });
  },
  data: function () {
    return {
      newUploadClicked: 0,
      reasonCodeList: []
    }
  },
  methods: {}
};
